import axios from 'axios';

export async function getGeoCode(zipCode, typeaheadAPIKey) {
  try {
    const searchData = {
      qq: `postalCode=${zipCode}`,
      in: 'countryCode:USA',
      lang: 'en-US',
      limit: 20,
      apikey: typeaheadAPIKey,
    };

    const response = await axios.get('https://geocode.search.hereapi.com/v1/geocode', {
      params: searchData,
    });

    return response.data?.items?.[0] ?? null;
  } catch (error) {
    console.error(error);
    return null;
  }
}
